<template>
  <MenuItem
    v-if="list"
    class="h11-links"
    data-qa="item-repeat"
    :disabled="disabled"
    icon="repeat"
    :label="$t('Purchasing.Repeat')"
    @click="copyItem"/>
  <sButton
    v-else
    class="px-2"
    color="var(--white-color)"
    data-qa="btn-repeat"
    :disabled="disabled"
    icon="repeat"
    type="text"
    @click="copyItem">
    {{ $t('Purchasing.Repeat') }}
  </sButton>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'

export default {
  name: 'copyItem',
  props: {
    copyItem: Function,
    list: Boolean,
    disabled: Boolean
  },
  components: {
    MenuItem
  }
}
</script>
